import React, { useState, useRef, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import './CommunityShareButton.scss';
import ShareIcon from '../../../Icons/ShareIcon/ShareIcon';
import CommunitySharePopup from './CommunitySharePopup/CommunitySharePopup';
import { EmitMetric } from '../../../Analytics/VisibilityPixel/VisibilityPixel';
import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';
import {
    emitEngagement,
    objectTypes,
} from '../../../../utilities/getStreamAnalytics';

const CommunityShareButton = ({ hash, location, showLabel }) => {
    const [isActive, setIsActive] = useState(false);
    const { getContent } = useContext(CommunityContext);
    const content = getContent(hash);
    const {
        pageProps: {
            session: { id, name },
        },
    } = useContext(PageContext);

    const node = useRef();
    // FUNCTIONS ======================================
    const handleClick = (e) => {
        if (node.current.contains(e.target)) {
            setIsActive(true);
            return;
        }
        setIsActive(false);
    };

    const emitMetric = (shareDestination) => {
        EmitMetric({
            community_content_key: `${content.type}-${content.hash}`,
            community_content_location: location,
            share_destination: shareDestination,
            misc_event_type: 'reaction-bar-share',
            share: 1,
        });
        const contentIsComment = content?.type === 'community-comment';
        const metricContent = contentIsComment
            ? {
                  foreign_id: `${objectTypes()[content.parentContentType]}:${
                      content.hash
                  }`,
                  comment_id: `${objectTypes()[content.type]}:${content.hash}`,
              }
            : {
                  foreign_id: `${objectTypes()[content.type]}:${content.hash}`,
              };
        emitEngagement(
            { id, name },
            {
                label: 'share',
                score: 1,
                content: metricContent,
            }
        );
        setIsActive(false);
    };

    const beforeOnClick = (shareDestination) => {
        return new Promise((resolve) => {
            emitMetric(shareDestination);
            emitEngagement(
                { id, name },
                {
                    label: 'share',
                    score: 1,
                    content: {
                        foreign_id: `${objectTypes()[content.type]}:${
                            content.hash
                        }`,
                    },
                }
            );
            resolve();
        });
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);
        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, []);

    return (
        <div
            className="component-Community-ReactionBar-CommunityShareButton"
            ref={node}
        >
            <button
                type="button"
                aria-label="share"
                className="share-button"
                onClick={handleClick}
            >
                <ShareIcon isActive={isActive} />
            </button>
            {showLabel && <p className="button-label">Share</p>}
            {isActive ? (
                <CommunitySharePopup
                    hash={hash}
                    beforeOnClick={beforeOnClick}
                    copyLinkMetric={emitMetric}
                />
            ) : null}
        </div>
    );
};

CommunityShareButton.propTypes = {
    hash: PropTypes.string.isRequired,
    location: PropTypes.string,
    showLabel: PropTypes.bool,
};

CommunityShareButton.defaultProps = {
    location: 'masterFeed',
    showLabel: false,
};

CommunityShareButton.displayName = 'CommunityShareButton';

export default React.memo(CommunityShareButton);
